import { Component } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter, catchError } from 'rxjs/operators';
import { IThirdNavCollapsibleElement } from 'src/app/common-page-components/third-nav-tab-component/third-nav-tab-component.component';
import { INews } from '../common-page-components/news-panel/news-panel.component';
import { HttpClient } from '@angular/common/http';
import { environment } from "@environments/environment";
import { of } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  showNav = false;

  /**
   * Property of indoor news
   *
   * @type {Array<INews>}
   * @memberof AppComponent
   */
  news: Array<INews>
  routes: Array<IThirdNavCollapsibleElement> = [
    { name: "Calendar", route: "calendar" },
    { name: "Elite ranking", route: "elite-ranking" },
    { name: "Open ranking", route: "open-ranking" },
    { name: 'Team ranking', route: 'team-ranking' }
  ];
  title = 'Calendar';
  constructor(router: Router, http: HttpClient) {
    router.events
      .pipe(filter(a => a instanceof NavigationStart))
      .subscribe((next: NavigationStart) => {
        switch (next.url) {
          case '/events/indoor/calendar':
            this.title = 'Calendar';
            break;
          case '/events/indoor/elite-ranking':
            this.title = 'Elite ranking';
            break;
          case '/events/indoor/open-ranking':
            this.title = 'Open ranking';
            break;
          case '/events/indoor/team-ranking':
            this.title = 'Team ranking';
        }
      });
    http.get(environment.news_api.indoor).pipe(catchError(e => of([]))).subscribe((next: any) => {
      this.news = next as any;
    });
  }
}
